// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const createAgGridApi = (gridApi, columnApi) => ({
    columnApi,
    gridApi,
    type: actions.CREATE_AG_GRID_API
});



// WEBPACK FOOTER //
// ./src/reports/shared/action-creators/create-ag-grid.js